module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Light.8079866.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceHanSansCN-Light.otf
// module id = DZeI
// module chunks = 1